import { useTranslation } from 'react-i18next'
import { Loader2, Search } from 'lucide-react'

/**
 * Full-page OAuth "completing sign-in" view shown while we decode the JWT
 * and resolve the post-login redirect.
 */
export function LoadingState() {
  const { t } = useTranslation()
  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 py-12">
      <div className="text-center space-y-4">
        <div className="mx-auto h-14 w-14 rounded-full bg-primary flex items-center justify-center mb-4">
          <Search className="h-6 w-6 text-primary-foreground" />
        </div>
        <Loader2 className="mx-auto h-6 w-6 animate-spin text-muted-foreground" />
        <p className="text-sm text-muted-foreground">{t('auth.oauth_completing')}</p>
      </div>
    </div>
  )
}
